module.exports = __webpack_public_path__ + "static/img/bg-ar.99a73e44.png";